import React from "react";
import styles from "./style.module.css";

import NumberFormat from "react-number-format";

const PURPLE = "rgb(126, 105, 205)";
const ORANGE = "rgb(239,126,84)";
const GRAY = "rgb(134,133,149)";

export default class WaterfallMobile extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      expanded: false
    };
  }

  //TO-DO: remove unused variables from component.
  //TO-DO: re-render component on screen width change

  renderStackedBar(bar, index) {
    const { isWide, handleOpenDeploy } = this.props;
    let margin = "calc(" + bar.marginLeft + ")";
    if (bar) {
      return (
        <div>
          <div
            className={styles.bar}
            style={{
              width: bar.width,
              marginLeft: margin,
              background: bar.color,
              flexGrow: bar.isHidden && 0,
              height: "10px",
              marginTop: "3px",
              marginBottom: "10px"
            }}
          >
            {bar.showTotalVal && (
              <div className={styles.barValue}>
                <NumberFormat
                  value={roundTotal ? Math.round(bar.value) : bar.value.toFixed(2)}
                  displayType={"text"}
                  thousandSeparator={true}
                />
              </div>
            )}
          </div>
        </div>
      );
    }
  }

  renderColor(key) {
    const { selectedMode } = this.props;

    if (selectedMode == "Overall") {
      return ORANGE;
    }

    return key == selectedMode ? ORANGE : GRAY;
  }

  toggleProjectNames() {
    const { expanded } = this.state;
    this.setState({ expanded: !expanded });
  }

  render() {
    const {
      bars,
      totalLabel,
      showTotalVal,
      isStacked,
      isWide,
      useTotal,
      hideTotal,
      hideLabels,
      isFlex,
      largest,
      projectData,
      profits,
      projectIDs
    } = this.props;

    const { expanded } = this.state;

    const colors = ["#92cf48", "#eb332b", "#b1d36f", "#d7a4aa", "var(--aible-color)"];

    let min = undefined;
    let max = undefined;
    let current = 0;

    let filterBars = bars.filter((b) => {
      return b !== undefined;
    });

    const maxVal = Math.max.apply(
      Math,
      filterBars.map((b) => b.value)
    );
    const minVal = Math.min.apply(
      Math,
      filterBars.map((b) => b.value)
    );

    for (const bar of filterBars) {
      if (bar.isHidden !== true) {
        current += bar.value;

        if (current < min || min === undefined) {
          min = current;
        }
        if (current > max || max === undefined) {
          max = current;
        }
      }
    }

    if (max > 0 && min > 0) {
      min = 0;
    }

    if (max < 0 && min < 0) {
      max = 0;
    }

    const expandWidth = window.innerWidth * 0.55;
    const totalSize = window.innerWidth - 40 - (expanded ? expandWidth : 76.98) - 63.17;

    // screen minus the bar component L/R pad minus the label widths

    if (isStacked) {
      max = totalSize;
    }

    if (largest) {
      max = largest;
    }

    let totalDelta = max - min;

    let rBars = [];
    let rCurrent = 0;
    let tCurrent = 0;
    let index = 0;

    const pColors = ["rgb(91, 207, 115)", "rgb(91, 207, 115)"];

    const nColors = ["rgb(192, 62, 89)", "rgb(192, 62, 89)"];

    const total = filterBars.reduce((acc, bar) => acc + bar.value, 0);
    const pixelConvert = max / total;
    for (const bar of filterBars) {
      const start = Math.min(rCurrent, rCurrent + bar.value);
      const end = Math.max(rCurrent, rCurrent + bar.value);
      rBars[index] = {
        ...bar,
        value: bar.value,
        marginLeft: (start - min) * pixelConvert + "px",
        width: largest === 0 || bar.value === 0 ? 0 + "%" : (end - start) * pixelConvert + "px",
        tooltip: [{ value: bar.value, count: bar.count }],
        color: this.renderColor(index)
      };

      if (bar.isHidden !== true) {
        tCurrent += bar.value;
      }

      rCurrent += bar.value;

      index++;
    }

    const marginLeft =
      tCurrent < 0
        ? (Math.abs(min - tCurrent) / totalDelta) * 100
        : min < 0
          ? (Math.abs(min) / totalDelta) * 100
          : min === 0
            ? 0
            : (Math.abs(min - tCurrent) / totalDelta) * 100;

    if (true) {
      rBars.push({
        value: tCurrent,
        marginLeft: marginLeft + "%",
        width: total * pixelConvert + "px",
        color: PURPLE,
        label: "Overall",
        tooltip: [{ value: tCurrent }],
        showTotalVal: showTotalVal,
        isTotal: true,
        tooltipLabel: rBars && rBars.length > 0 ? rBars[0].tooltipLabel : undefined
      });
    }

    let displayProfits = profits.filter((p) => {
      return p !== undefined;
    });

    return (
      <div className={styles.valueMatrixHolder} style={{ width: "100%", whiteSpace: expanded ? "unset" : "" }}>
        {/* <div className={styles.barLabels + (expanded ? " " + styles.barLabelsExpanded : "")}
          onClick={() => this.toggleProjectNames()}>
          { projectData && projectData.map(project =>{
            const idx = projectIDs.indexOf(project.id)
            // if (true){
            if (profits[idx]){
              return (<div className={styles.barLabel}>{project.name}</div>)
            }
          })}
          <div className={styles.barLabel}>Overall</div>
        </div>
        <div style={{width: '100%'}}>
        {rBars.map((bar, index) => {
        return(
          <div style={{width: "100%"}}>
          {this.renderStackedBar(bar, index)}
          </div>
        )}
        )}
        </div>
        <div className={styles.valueLabels}>
        { projectData && projectData.map(project =>{
            const idx = filterBars.map(f => f.id).indexOf(project.id)
            // if (true){
            if (displayProfits[idx]){
              return (<div className={styles.valueLabel}>{"$" + filterBars[idx].value}</div>)
            }
          })}
          <div className={styles.valueLabel}>${total}</div>
        </div> */}
        {rBars.map((bar, index) => (
          <div key={index} style={{ display: "flex", flexDirection: "row" }}>
            <div
              className={styles.barLabel + (expanded ? " " + styles.barLabelsExpanded : "")}
              onClick={() => this.toggleProjectNames()}
            >
              {bar.label}
            </div>
            <div>{this.renderStackedBar(bar, index)}</div>
            <div className={styles.valueLabel}>{"$" + bar.value}</div>
          </div>
        ))}
      </div>
    );
  }
}
